// utils/request.js
import axios from 'axios'

const BASE_URL = 'https://anjat.bolerunjing.cn/An74/api' // 改成你的后端地址

export function request({ url, method = 'get', data = {}, params = {} }) {
  const token = localStorage.getItem('token')

  return axios({
    baseURL: BASE_URL,
    url,
    method,
    data,
    params,
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    },
    withCredentials: true
  })
}
